/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCleaningServicesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-cleaning-services"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 23.8Q3.73 23.8 2.96 23.04Q2.2 22.27 2.2 21.15L2.2 16.2Q2.2 13.9 3.83 12.29Q5.45 10.68 7.75 10.68L8.55 10.68L8.55 2.83Q8.55 1.73 9.31 0.96Q10.07 0.2 11.18 0.2L12.8 0.2Q13.9 0.2 14.66 0.96Q15.43 1.73 15.43 2.83L15.43 10.68L16.23 10.68Q18.55 10.68 20.18 12.29Q21.8 13.9 21.8 16.2L21.8 21.15Q21.8 22.27 21.04 23.04Q20.27 23.8 19.15 23.8ZM4.85 21.15L6.45 21.15L6.45 18.3Q6.45 17.73 6.84 17.34Q7.22 16.95 7.8 16.95Q8.35 16.95 8.72 17.35Q9.1 17.75 9.1 18.3L9.1 21.15L10.68 21.15L10.68 18.3Q10.68 17.73 11.06 17.34Q11.45 16.95 12.03 16.95Q12.57 16.95 12.95 17.35Q13.32 17.75 13.32 18.3L13.32 21.15L14.9 21.15L14.9 18.3Q14.9 17.73 15.29 17.34Q15.68 16.95 16.23 16.95Q16.77 16.95 17.16 17.34Q17.55 17.73 17.55 18.3L17.55 21.15L19.15 21.15Q19.15 21.15 19.15 21.15Q19.15 21.15 19.15 21.15L19.15 16.2Q19.15 15 18.29 14.16Q17.43 13.32 16.23 13.32L7.75 13.32Q6.55 13.32 5.7 14.16Q4.85 15 4.85 16.2L4.85 21.15Q4.85 21.15 4.85 21.15Q4.85 21.15 4.85 21.15Z" fill={color} />
    </svg>
  );
}
